import http from '@/utils/http'
// 用户注册相关接口


// 省市区三级联动
export function getAllProvince() {
  return http.get('/cs/dict/getProvince')
}

export function getCityByProvince(code) {
  return http.get(`/cs/dict/getCity?code=${code}`)
}

export function getAreaByCity(code) {
  return http.get(`/cs/dict/getArea?code=${code}`)
}


// 获取所有国家
export function getAllCountry() {
  return http.get(`/cs/dict/country`)
}



// 获取用户已注册的信息
export function getRegisterInfo(headers, data) {
  const config = {
    method: 'GET',
    url: `/user/user/userInfo`,
    data,
    headers
  }
  return http(config)
}



// 提交用户注册表单
export function submitVisitorRegisterForm(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/attend/signUp`,
    data,
    headers
  }
  return http(config)
}


// 用户审核列表
export function getAudienceList(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/attend/audienceAuditList`,
    data,
    headers
  }
  return http(config)
}


// 审核操作
export function auditUserSign(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/attend/audit`,
    data,
    headers
  }
  return http(config)
}

// 检查当前用户是否注册状态
export function checkRegisterStatus(headers, identity, meetingCode) {
  const config = {
    method: 'POST',
    url: `/user/attend/checkSignUpStatus/${identity}/${meetingCode}`,
    headers
  }
  return http(config)
}


// 查询当前用户报名状态详情
export function registerUserDetail(headers, meetingCode, audienceUid) {
  const config = {
    method: 'GET',
    url: `/user/attend/audienceAuditDetail/${meetingCode}/${audienceUid}`,
    headers
  }
  return http(config)
}




// 判断用户是否实名
// url: '',
// 查询当前用户报名状态详情
export function checkUserRealName(headers) {
  const config = {
    method: 'GET',
    url: `/user/wemeet/checkRealName`,
    headers
  }
  return http(config)
}

// 同步用户信息

export function syncUserInfo(headers) {
  const config = {
    method: 'GET',
    url: `/user/wemeet/getUserBaseInfoBySync`,
    headers
  }
  return http(config)
}


// 一次性提交用户注册信息
export function submitUserInfoByBasicInfo(headers, data) {
  const config = {
    method: 'POST',
    url: `/user/attend/signUpAndRegister`,
    data,
    headers
  }
  return http(config)
}



